import {Badge, Button, Divider, Typography} from '@kaman/uikit';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {IGetStoreProductsResponse} from '../../../models/store.model';
import {setSheetHeader} from '../../../redux/sheetHeader/sheetHeaderSlice';
import Banners from '../../../components/banners/Banners';

export default function ProductPreview() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const product = location.state as IGetStoreProductsResponse | null;

    useEffect(() => {
        if (!product) {
            navigate(-1);
            return;
        }

        dispatch(
            setSheetHeader({
                title: '',
                showBack: true,
                showShare: false,
                contentOverlap: true,
                contentPadding: '0px',
            })
        );
    }, [dispatch, navigate, product]);

    if (!product) {
        return null;
    }

    const hasDiscount =
        !!product.discountedPercent && product.discountedPercent > 0;
    const displayPrice = product.price;
    const originalPrice = hasDiscount
        ? (product.price ?? 0) + (product.discountedPrice ?? 0)
        : null;
    const currency = product.currency || 'تومان';
    const actionTitle = product.commandTitle || 'مشاهده محصول';
    const productTitle = product.title.trim();
    const truncatedTitle =
        productTitle.length > 50
            ? `${productTitle.slice(0, 50)}…`
            : productTitle;

    const openProduct = () => {
        const route = product.route;
        if (!route) return;
        if (/^https?:\/\//i.test(route)) {
            window.open(route, '_blank', 'noopener,noreferrer');
            return;
        }
        navigate(route);
    };

    return (
        <main className="flex w-full min-w-0 flex-col gap-2">
            <section className="flex flex-col overflow-hidden rounded-2xl bg-white px-4 pb-4">
                <div className="relative mt-4 w-full overflow-hidden rounded-2xl">
                    {product.logoUrl ? (
                        <img
                            src={product.logoUrl}
                            alt=""
                            className="absolute end-3 top-3 h-8 w-8 rounded-full bg-white object-contain shadow-sm"
                        />
                    ) : null}
                    {product.imageUrl ? (
                        <img
                            src={product.imageUrl}
                            alt={product.title}
                            className="block h-auto w-full object-cover"
                        />
                    ) : null}
                </div>

                <div className="mt-3 flex min-w-0 items-center justify-between gap-3">
                    <Typography
                        variant="body-normal"
                        className="min-w-0 flex-1 text-right font-bold text-gray-900"
                        title={productTitle}
                    >
                        {truncatedTitle}
                    </Typography>
                    <div className="flex shrink-0 flex-col items-end gap-1">
                        {(originalPrice != null || hasDiscount) && (
                            <div className="flex items-center gap-2">
                                {hasDiscount && (
                                    <Badge
                                        text={`${product.discountedPercent?.toLocaleString('fa')}٪`}
                                        size="sm"
                                        variant="solid"
                                        backgroundColor="#FB3A43"
                                        textColor="white"
                                    />
                                )}
                                {originalPrice != null && (
                                    <Typography
                                        variant="body-small"
                                        color="gray"
                                        className="line-through"
                                    >
                                        {originalPrice.toLocaleString('fa')}
                                    </Typography>
                                )}
                            </div>
                        )}
                        {displayPrice != null && (
                            <Typography
                                variant="body-small"
                                className="font-bold text-gray-900"
                            >
                                {displayPrice.toLocaleString('fa')} {currency}
                            </Typography>
                        )}
                    </div>
                </div>
                <Button
                    type="button"
                    variant="filled"
                    className="mt-4 w-full"
                    onClick={openProduct}
                    disabled={!product.route}
                >
                    {actionTitle}
                </Button>
            </section>
            <Divider className="h-1 bg-[#F6F6F6]" />
            <Banners bannerType="ProductInfo" />
        </main>
    );
}
